import { formatEntityName } from '../../../common';
import { SchemaBuilderError } from '../../builder/SchemaBuilder';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
export const removeEntityStmtInstruction = `
#### Entity removal
- Syntax: \`remove entity <entity_name>;\`
- Example: \`remove entity Book;\``;
export const stmtRemoveEntity = ({ entityName }) => {
    return `remove entity ${entityName};`;
};
export const stmtForHumanRemoveEntity = ({ entityName }) => {
    return `Remove the database table __${entityName}__.`;
};
export const removeEntityHandler = createSchemaStatementHandler({
    type: 'remove entity',
    parse: line => {
        const match = /^remove entity (?<entityName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'remove entity',
                entityName: formatEntityName(match.groups.entityName),
            }
            : null;
    },
    getHumanStmt: stmtForHumanRemoveEntity,
    apply: (stmt, builder) => {
        builder.updateSchema(it => {
            const pluginEntity = Object.values(builder.extensions.plugins).filter(plugin => plugin.schema?.model.entities[stmt.entityName])?.[0];
            if (pluginEntity) {
                throw new SchemaBuilderError(`Cannot remove entity ${stmt.entityName} because it is used in a plugin. if you want to remove it, remove the ${pluginEntity.name} plugin first.`);
            }
            return it.removeEntity(stmt.entityName);
        });
        builder.updateSchemaExtensions(it => {
            // TODO: create SchemaExtensionsBuilder with removeEntity method
            it = {
                ...it,
                comments: Object.fromEntries(Object.entries(it.comments).filter(([entityName]) => entityName !== stmt.entityName)),
                plugins: Object.fromEntries(Object.entries(it.plugins).filter(([entityName]) => entityName !== stmt.entityName)),
                translatable: Object.fromEntries(Object.entries(it.translatable).filter(([entityName]) => entityName !== stmt.entityName)),
            };
            return it;
        });
    },
});
//# sourceMappingURL=RemoveEntityStmt.js.map